export default {
  namespaced: true,
  state: {
    categoriasCnh: [
      {
        value: 'A',
        label: 'A',
      },
      {
        value: 'B',
        label: 'B',
      },
      {
        value: 'C',
        label: 'C',
      },
      {
        value: 'D',
        label: 'D',
      },
      {
        value: 'E',
        label: 'E',
      },
      {
        value: 'AB',
        label: 'AB',
      },
      {
        value: 'AC',
        label: 'AC',
      },
      {
        value: 'AD',
        label: 'AD',
      },
      {
        value: 'ACC',
        label: 'ACC',
      },
    ],
  },
};
